import { forms } from '../services/bff.api';

export const OFFERING_FORM_OPTIONS_RESOURCE = {
  key: 'OFFERING_FORM_OPTIONS_RESOURCE',
  table: {
    defaultSort: '',
    dataLocation: '_embedded.resourceList',
    dataTransform: (data) => data?.map((form) => ({ value: form.identifier, label: form.name, meta: form }))
  },
  api: {
    get: forms.getForOffering
  }
};
